import { render, staticRenderFns } from "./TemplateHighlightSectionMobile.vue?vue&type=template&id=b97f6cd8&scoped=true&"
import script from "./TemplateHighlightSectionMobile.vue?vue&type=script&lang=js&"
export * from "./TemplateHighlightSectionMobile.vue?vue&type=script&lang=js&"
import style0 from "./TemplateHighlightSectionMobile.vue?vue&type=style&index=0&id=b97f6cd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97f6cd8",
  null
  
)

export default component.exports